import { gql } from "gql";

export const GET_NEED_SETUP_MODULE_SETTINGS = gql(/* GraphQL */ `
  query GetNeedSetupModuleSettings {
    getNeedSetupModuleSettings
  }
`);
